import { createFileRoute } from '@tanstack/react-router'

import { MasterStep } from '@/pages/create-booking-page'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard/master/')({
    component: MasterStep,
})
